/** Submit a form through its own submit handlers, the way a click or Enter does.
 *
 * `requestSubmit` says exactly this, but WebKit only shipped it in Safari 16:
 * below that it is undefined, so calling it throws a TypeError that strands a
 * code the visitor has already finished entering. Dispatching the event is
 * equivalent for these forms — they carry `novalidate`, so the constraint
 * validation `requestSubmit` would add has nothing to do.
 *
 * `form.submit()` is not the fallback: it submits natively without firing a
 * submit event, so the handler that owns the request never runs.
 */
function submitForm(form: HTMLFormElement): void {
  if (typeof form.requestSubmit === "function") {
    form.requestSubmit();
    return;
  }
  form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
}

export { submitForm };
